import { cn } from '@/lib/cn';

type BrandLogoProps = {
  className?: string;
  variant?: 'full' | 'icon';
};

const iconImageUrl = new URL('../../assets/branding/advoltix-logo.png', import.meta.url).href;

export function BrandLogo({ className, variant = 'full' }: BrandLogoProps) {
  const isIconOnly = variant === 'icon';

  return (
    <div className={cn('inline-flex items-center gap-2.5', className)} aria-label="Advoltix">
      <img
        src={iconImageUrl}
        alt="Advoltix"
        className={cn(
          'select-none object-contain',
          isIconOnly ? 'h-9 w-9 sm:h-11 sm:w-11' : 'h-8 w-8 sm:h-9 sm:w-9'
        )}
        decoding="async"
        loading="lazy"
        draggable={false}
      />
      {!isIconOnly ? (
        <span
          className="font-display text-sm font-bold tracking-[0.3em] text-white sm:text-[0.9rem]"
          style={{ textShadow: '0 0 20px rgba(99,102,241,0.4)' }}
        >
          ADVOLTIX
        </span>
      ) : null}
    </div>
  );
}
